<template>
  <div id="application-create-details">
    <div class="vx-row">
      <div class="vx-col w-1/2">
        <vs-input class="w-full mt-4" label="Name" v-model="data_local.ApplicationName"
                  v-validate="'required'"
                  name="ApplicationName" />
        <validation-message v-show="vErrors.has('ApplicationName')">
          {{ vErrors.first("ApplicationName") }}
        </validation-message>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-input class="w-full mt-4" label="Description"
                  v-model="data_local.ApplicationDescription"
                  v-validate="'required'"
                  name="ApplicationDescription" />
        <validation-message v-show="vErrors.has('ApplicationDescription')">
          {{ vErrors.first("ApplicationDescription") }}
        </validation-message>
      </div>
    </div>
    <div class="vx-row mt-4">
      <div class="vx-col w-1/2 mt-4">
        <label class="vs-input--label mt-4">Application Type</label>
        <v-select v-model="data_local.ExternalIdentity.app_type"
                  :clearable="false"
                  :options="applicationTypeOptions"
                  v-validate="'required'"
                  name="app_type" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        <validation-message v-show="vErrors.has('app_type')">
          {{ vErrors.first("app_type") }}
        </validation-message>
      </div>
      <div class="vx-col w-1/2">
        <vs-input class="w-full mt-4"
                  label="Application Login URI"
                  v-model="data_local.ExternalIdentity.initiate_login_uri"
                  v-validate="'required|url'"
                  name="initiate_login_uri" />
        <validation-message v-show="vErrors.has('initiate_login_uri')">
          {{ vErrors.first("initiate_login_uri") }}
        </validation-message>
      </div>
    </div>

  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.value)),
      applicationType: null,
      applicationTypeOptions: [
        {
          label: 'Machine to Machine',
          value: 'non_interactive',
        },
        {
          label: 'Native',
          value: 'native',
        },
        {
          label: 'Regular Web Application',
          value: 'regular_web',
        },
        {
          label: 'Single Page Application',
          value: 'spa',
        },
      ]
    }
  },
  watch: {
    data_local: {
      handler(newData) {
        this.$emit('input', newData);
      },
      deep: true,
    },
  },
}
</script>
